module.exports = __webpack_public_path__ + "assets/Pocket.a1a67879.svg";